import { useMutation } from '@apollo/client/react';
import { Alert, AlertTitle, Button, Typography } from '@mui/material';
import { RotateCcw } from 'lucide-react';
import { useParams } from 'react-router-dom';

import { gql } from '@graphql/__generated__';
import { useLocale } from '@shared/hooks/locale';
import { getUUID } from '@shared/utils/global-id';

const RESTORE_USER = gql(/* GraphQL */ `
  mutation RestoreUser($id: uuid!) {
    update_users_by_pk(pk_columns: { id: $id }, _set: { is_deleted: false }) {
      id
      is_deleted
    }
  }
`);

export const DeletedUser = () => {
  const { t } = useLocale();
  const { userId } = useParams() as { userId: string };
  const id = getUUID(userId);
  const [restoreUser, { loading }] = useMutation(RESTORE_USER);

  return (
    <Alert severity="error" sx={{ m: 2, mb: 0, alignItems: 'center' }}>
      <AlertTitle sx={{ mb: 0.5 }}>
        {t('This user has been deleted')}
      </AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t(
          'Restoring this user does not cancel document-tracking erasure. Once erased, past views stay deleted and new document views will not be tracked for this user.',
        )}
      </Typography>
      <Button
        variant="soft"
        color="error"
        size="small"
        loading={loading}
        startIcon={<RotateCcw />}
        onClick={() => restoreUser({ variables: { id } })}
      >
        {t('Restore user')}
      </Button>
    </Alert>
  );
};
